define(['jquery'], function ($) {
    'use strict';

    var cache = {};

    $.ajaxSetup({'cache': false});

    return {

        getCachedXhrPromise: function (method, url, data) {
            data = data || {};

            var hash = JSON.stringify($.makeArray(arguments));

            if (cache[hash] !== undefined) {
                return cache[hash];
            }

            // options.r = new Date().getTime();
            cache[hash] = $.ajax({
                'method': method,
                'url': url,
                'data': data
            }).then(function (value) {
                return value;
            });

            return cache[hash];
        }

    };
});
